// src/context/NotificationContext.js
import { createContext, useContext, useState } from 'react';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  // Add notification function
  const addNotification = (notification) => {
    setNotifications(prev => [
      {
        id: Date.now(),
        message: notification.message,
        time: new Date().toLocaleTimeString(),
        ...notification
      },
      ...prev
    ]);
  };

  // Clear notifications
  const clearNotifications = () => {
    setNotifications([]);
  };

  return (
    <NotificationContext.Provider value={{ notifications, addNotification, clearNotifications }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within a NotificationProvider');
  }
  return context;
};